import React from "react";
import Svg, { Path } from "react-native-svg";

const Previous = ({ strokeColor = "black" }) => {
  return (
    <Svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M10 18L2 10L10 2"
        stroke={strokeColor}
        stroke-opacity="0.56"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  );
};

export default Previous;
